import React, { useEffect, useState } from 'react';
import { Row, Col, Image, Button } from 'react-bootstrap';
import ZoomModal from './ZoomModal';
import { useAuth } from '../../auth/Auth';
import {
  getSpecialCountTime,
  getUpcomingTime
} from '../../../utils/camp.utils';
import './css/camp.schedule.scss';
import Countdown, { zeroPad } from 'react-countdown';
import { useHistory } from 'react-router-dom';
import { specialCampViewModel } from '../special_camp/special.camp.viewmodel';
import ZoomButtonSpecialCamp from './ZoomButtonSpecialCamp';

const TribeCamp = (props) => {
  const { dependent, logout, school } = useAuth();
  const history = useHistory();
  const [showZoomModal, setShowZoomModal] = useState(false);
  const handleCloseZoomModal = () => setShowZoomModal(false);
  const handleShowZoomModal = () => setShowZoomModal(true);
  const [specialCamp, setSpecialCamp] = useState({});
  const [isCompleted, setIsCompleted] = useState(false);
  const [isSpecialCampShow, setIsSpecialCampShow] = useState(false);
  const group = props.selectedTreehouse[0] ? props.selectedTreehouse[0] : "";
  const [key, setKey] = useState(0);
  const [days, setDays] = useState(null);
  const [isPrompt, setIsPrompt] = useState(false);
  const [showCampJoin, setShowCampJoin] = useState(false);

  const getSchedule = () => {

    const convertedTime = getUpcomingTime(
      group.day,
      group.time,
      group.timezone
    );

    return `${convertedTime}`;
  };

  const getSpecialCampSchedule = () => {
    const convertedTime = getSpecialCountTime(specialCamp.start_date_time, specialCamp.timezone)
    return convertedTime
  }

  const countdownRendererSchool = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      setShowCampJoin(true)
      return null
    } else {
      setShowCampJoin(false)
      return (
        <h5 className='f-600'>
          <div class="countdown">
            <div class="counts-days">
              <span id="days">{days}</span><br />
              <span>Days</span>
            </div>
            <div class="counts-days">
              <span id="hrs">{zeroPad(hours)}</span><br />
              <span>hrs</span>
            </div>
            <div class="counts-days">
              <span id="mins">{zeroPad(minutes)}</span><br />
              <span>mins</span>
            </div>
            <div class="counts-days">
              <span id="secs">{zeroPad(seconds)}</span><br />
              <span>secs</span>
            </div>
          </div>
        </h5>
      );
    }
  };

  const getSpecialCamps = () => {
    if (school?.user_type === "school") {
      specialCampViewModel.getSchoolUpcomingSpecialCamp(school?.id).then((res) => {
        setSpecialCamp(res)
        props?.setCampMasterSpecialCamp(res)
      }).catch((err) => {
        console.log(err)
      })
    }
  }

  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      setIsSpecialCampShow(true)
      // return (
      //   <span>
      //     {days}:{zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
      //   </span>
      // );
      return null
    } else {
      return (
        <h5 className='f-600'>
          <div class="countdown" style={{ gap: 10, }}>
            <div class="counts-days">
              <span id="days">{days}</span><br />
              <span>Days</span>
            </div>
            <div class="counts-days">
              <span id="hrs">{zeroPad(hours)}</span><br />
              <span>hrs</span>
            </div>
            <div class="counts-days">
              <span id="mins">{zeroPad(minutes)}</span><br />
              <span>mins</span>
            </div>
            <div class="counts-days">
              <span id="secs">{zeroPad(seconds)}</span><br />
              <span>secs</span>
            </div>
          </div>
        </h5>
      );
    }
  };

  useEffect(() => {
    if (props?.selectedTreehouse === "All") {
      getSpecialCamps()
    } else {
      setSpecialCamp({})
    }
  }, [props.selectedTreehouse])

  return (
    <div className="camp-schedule-container creator-camp-box creator-camp-box-new justify-content-center text-center hide-on-toggle tribecamp" style={{ padding: 0 }}>
      {/* <div className="camp-schedule-title p-3">Upcoming Camp</div> */}
      {/* <div className="camp-schedule-time p-2">{getSchedule()}</div> */}
      {group?.id &&
        <div className='inner-camp-box' style={{ padding: 0 }}>
          <div className='width-box' style={{ padding: 0 }}>
            <span className={!showCampJoin ? 'counter' : ''}>
              <Countdown
                key={key}
                date={Date.now() + Number(getSchedule())}
                renderer={countdownRendererSchool}
              // overtime={true}
              // onComplete={handleComplete}
              />
            </span>
          </div>

          <div className="join-button px-3">
            {showCampJoin ?
              group?.meet_link ?
                <ZoomButtonSpecialCamp title="Join Camp" link={group?.meet_link} /> :
                group?.zoom_link ?
                  <ZoomButtonSpecialCamp title="Join Camp" link={group?.zoom_link} /> :
                  // <ZoomButton title="Join Camp" creator={dependent} />
                  ''
              : ''
            }
          </div>
          {showCampJoin ?
            !group.meet_link && group.zoom_link &&
            <>
              <Row
                className={`p-3 justify-content-center camp-schedule-zoom-details`}
                onClick={handleShowZoomModal}
              >
                <Col className="col-auto">
                  <div className={`camp-schedule-details `}>
                    Check Meeting Id & Password &gt;
                  </div>
                </Col>
              </Row>
              <ZoomModal showModal={showZoomModal} handleClose={handleCloseZoomModal} />
            </>
            : ''
          }
        </div>
      }
      {specialCamp?.id &&
        <div className='inner-camp-box' style={{ padding: 0 }}>
          {!isSpecialCampShow &&
            <div className='width-box' style={{ padding: 0 }}>
              {/* <span className={!showCampJoin ? 'counter' : ''}> */}
              <Countdown
                date={Date.now() + Number(getSpecialCampSchedule())}
                renderer={countdownRenderer}
              // overtime={true}
              // onComplete={handleComplete}
              />
              {/* </span> */}
            </div>
          }
          <div className="join-button px-3 pt-3">
            {isSpecialCampShow &&
              <ZoomButtonSpecialCamp title="Join Camp" link={specialCamp?.zoom_link} />
            }
          </div>
        </div>
      }
    </div>
  );
};

export default TribeCamp;
